export default __webpack_public_path__ + "static/media/cert-0x-2.5844c7ab.svg";